import $ from 'jquery';
import grecaptcha from 'grecaptcha';
import { track } from './tracking';

$(function () {
    const enTerms = {
        'PlaceholderSales': 'Please tell us a little bit about your inspection needs & expected delivery time',
        'PlaceholderPartner': 'Please tell us a little bit about your company & why you are interested in becoming a partner'
    };

    const noTerms = {
        'PlaceholderSales': 'Fortell oss litt om dine inspeksjonsbehov og forventet leveringstid',
        'PlaceholderPartner': 'Fortell oss litt om selskapet ditt og hvorfor du er interessert i å bli partner'
    };

    const currentLang = $('#CurrentLanguage').val();
    const terms = (currentLang === 'nb-NO') ? noTerms : enTerms;

    const reCaptchaPublicKey = $("#ReCaptchaKey").val();
    $('.company-info-required').hide();

    $('#input--category').on('change', function (e) {
        const isSales = $(this).val() === 'sales';
        const isPartner = $(this).val() === 'partner';

        if (isSales) {
            $('.company-info-required').show();
            $('#input--message').attr('placeholder', terms['PlaceholderSales']);
        } else if(isPartner) {
            $('.company-info-required').show();
            $('#input--message').attr('placeholder', terms['PlaceholderPartner']);
        } else {
            $('.company-info-required').hide();
            $('#input--message').attr('placeholder', '');
        }
    });

    function titleCase(str) {
        str = str.toLowerCase().split(' ');
        for (let i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    }

    // On submit.
    $('#contact-form').on('submit', function (e) {
        e.preventDefault();

        // track
        track('Contact Form', 'Submit', 'Start');

        let valid = true,
            errorResponse = [],
            $firstName = $('#input--first-name'),
            $lastName = $('#input--surname'),
            $email = $('#input--email'),
            $phone = $('#input--phone'),
            $message = $('#input--message'),
            $subject = $('#input--subject'),
            emailTest = /\S+@\S+\.\S+/,
            numberTest = /^\d+$/,
            phoneTest = /^\+[1-9]\d{1,14}$/,
            $button = $('#contact-form-button'),
            $category = $('#input--category'),
            $industry = $('#Industry'),
            $company = $('#input--company');

        // pre validation, remove error classes
        $('.input--error').removeClass('input--error');

        // clear any error messages
        $('.form__error').removeClass('form__error--open').html('');

        // disable submit and animate
        $button.prop('disabled', true).addClass('buy-process__button--disabled');

        // first name is empty
        if ($firstName.val().length === 0) {
            valid = false;
            $firstName.addClass('input--error');
            errorResponse.push('You need to enter a first name.');
        }

        // last name is empty
        if ($lastName.val().length === 0) {
          valid = false;
          $lastName.addClass('input--error');
          errorResponse.push('You need to enter a surname.');
        }

        // email is not valid
        if (!emailTest.test($email.val())) {
            valid = false;
            $email.addClass('input--error');
            errorResponse.push('E-mail seems to be wrong.');
        }

        // phone is not valid
        if ($phone.val().length > 0 && !phoneTest.test($phone.val())) {
            valid = false;
            $phone.addClass('input--error');
            errorResponse.push('Phone number seems to be wrong, have you included country code (ie +47)?');
        }

        // subject is too short
        if ($subject.val().length < 5) {
            valid = false;
            $subject.addClass('input--error');
            errorResponse.push('You need to give your message a subject.');
        }

        // category is not selected
        if ($category.val().length === 0) {
            valid = false;
            $category.addClass('input--error');
            errorResponse.push('You need to select a category for your request.');
        }

        // validate required fields for sales
        if (isSalesCategory($category)) {
          if ($company.val().length === 0) {
            valid = false;
            $company.addClass('input--error');
            errorResponse.push('You need to provide a company name.');
          }
          if ($industry.val().length === 0) {
            valid = false;
            $industry.addClass('input--error');
            errorResponse.push('You need to select an industry.');
          }
        }

        // form is not valid
        if (!valid) {
            // track
            track('Contact Form', 'Submit', 'Error');

            $.each(errorResponse, function (i, message) {
                $('.form__error').append('<span>' + message + '</span>').addClass('form__error--open');
            });

            // enable submit and remove animation
            $button.prop('disabled', false).removeClass('buy-process__button--disabled');

        } else {
            grecaptcha.ready(function() {
                grecaptcha.execute(reCaptchaPublicKey, { action: 'submit_contact_form' }).then(function(token) {
                    $("#ReCaptchaToken").val(token);
                    submitForm();
                });
            });
        }
        return false;
    });

    function isSalesCategory($category) {
      return $category.val() === 'sales' || $category.val() === 'partner';
    }

    // Submit contact form as ajax request.
    function submitForm() {
        let $button = $('#contact-form-button'),
            $form = $('.contact__form'),
            $category = $('#input--category'),
            data = $form.serialize();

        $.ajax({
            type: 'POST',
            url: $form.data('url'),
            data: data,
            success: function (data, textStatus, jqXHR) {
                // track
                if ($category && $category.val()) {
                    track('Contact-Form-' + titleCase($category.val()), 'Submit', 'Success');
                }

                // enable submit and remove animation
                $button.prop('disabled', false).removeClass('buy-process__button--disabled');

                if (data.ContactFailed == false) {

                    // show modal window
                    NS.openOverlay();
                    NS.openModal('modal--contact-success');

                    // clear form in background
                    $('input').val('');
                    $('textarea').val('');

                } else {
                    // payment failed, error message set on response object
                    // output error message
                    $('.form__error').append('<span>' + data.ErrorMessage + '</span>').addClass('form__error--open');

                    // enable submit and remove animation
                    $button.prop('disabled', false).removeClass('buy-process__button--disabled');
                }
            },
            error: function (jqXHR, textStatus, error) {
                // output error message
                $('.form__error').append('<span>UNKNOWN ERROR! ' + jqXHR  + '</span><span>' + textStatus  + '</span><span>' + error  + '</span>').addClass('form__error--open');

                // enable submit and remove animation
                $button.prop('disabled', false).removeClass('buy-process__button--disabled');
            }
        });
    }
});